import React, { useState } from "react";
import HTMLReactParser from "html-react-parser";
import millify from "millify";
import { useParams } from "react-router-dom";
import { Col, Row, Typography, Select } from "antd";
import {
    MoneyCollectOutlined,
    DollarCircleOutlined,
    FundOutlined,
    ExclamationCircleOutlined,
    TrophyOutlined,
    NumberOutlined,
    ThunderboltOutlined,
} from "@ant-design/icons";
import LineChart from "./LineChart";

import { useGetCryptosDetailsQuery, useGetCryptosHistoryQuery } from "../../services/cryptoAPI";

const { Title, Text } = Typography;
const { Option } = Select;

const CryptoDetails = () => {
    const { coinId } = useParams();
    const [timePeriod, setTimePeriod] = useState("7d");
    const { data, isFetching } = useGetCryptosDetailsQuery(coinId);
    const { data: coinHistory } = useGetCryptosHistoryQuery({coinId, timePeriod});

    // console.log(coinHistory) 
    const cryptoDetails = data?.data?.coin
    
    if(isFetching) return "Loading..."

   
    
    const time = ["3h", "24h", "7d", "30d", "3m", "1y", "3y", "5y"];

    const stats = [
        {
            title: 'Price to USD', value : `$ ${cryptoDetails?.price && millify(cryptoDetails?.price)}`, icon: <DollarCircleOutlined />
        },
        {
            title: "Rank", value: cryptoDetails?.rank, icon: <NumberOutlined />
        },
        {
            title: '24h Volume', value: `$ ${cryptoDetails?.volume && millify(cryptoDetails?.volume)}`, icon: <ThunderboltOutlined />
        },
        {
            title: 'Market Cap', value : `$ ${cryptoDetails?.marketCap && millify(cryptoDetails?.marketCap)}`, icon: <DollarCircleOutlined />
        },
        {
            title: 'All time high(daily avg.)', value : `$ ${cryptoDetails?.allTimeHigh?.price && millify(cryptoDetails?.allTimeHigh?.price)}`, icon : <TrophyOutlined />
        }

    ]

    const genericStats = [
        {
            title: 'Number of markets', value: cryptoDetails?.numberOfMarkets, icon: <FundOutlined />
        },
        {
            title: "Number of excahnges", value: cryptoDetails?.numberOfExchanges, icon: <MoneyCollectOutlined />
        },
        {
            title: "Aproved Supply", value: String(cryptoDetails?.supply?.confirmed), icon: <ExclamationCircleOutlined />
        },
        {
            title: "Ttal Supply", value: `$ ${cryptoDetails?.supply?.total && millify(cryptoDetails?.supply?.total) }`, icon: <ExclamationCircleOutlined />
        },
        {
            title: "Circulating supply", value: `$ ${cryptoDetails?.supply?.circulating && millify(cryptoDetails?.supply?.circulating)}`, icon: <ExclamationCircleOutlined />
        },
    ]

    return (
        <>
            <Col className="coin-deatils-container" >
                <Col className="coin-heading-container">
                    <Title level={2} className="coin-name">
                        {cryptoDetails?.name}({cryptoDetails?.symbol}) Price
                    </Title>
                    <p>{ cryptoDetails?.name} live price in US dollars.
                        View value statistics, market cap and supply. 
                    </p>
                    
                </Col>
                <Select defaultValue='7d' className="select-timeperiod" placeholder="Select Timeperiod" onChange={(value)=>setTimePeriod(value)}>
                    {time.map((date)=> <Option key={date} >{date}</Option>)}
                </Select>
                
                <LineChart coinHistory={coinHistory} currentPrice={millify(cryptoDetails?.price)} coinName={cryptoDetails?.name } />
                
                <Col className="stats-container">
                    <Col className="coin-value-statistics">
                        <Col className="coin-value-statistics-heading">
                            <Title level={3} className="coin-details-heading">
                                {cryptoDetails?.name} value Statistics
                            </Title>
                            <p>
                                An overview showing the stats of {cryptoDetails?.name}
                            </p>
                        </Col>
                        {
                            stats.map(({icon, title, value}, index)=>(
                                <Col className="coin-stats" key={index}>
                                    <Col className="coin-stats-name">
                                        <Text>{icon}</Text>
                                        <Text>{title}</Text>
                                    </Col>
                                    <Text className="stats">{value}</Text>
                                </Col>
                            ))
                        }
                    </Col>
                    <Col className="other-stats-info">
                        <Col className="coin-value-statistics-heading">
                            <Title level={3} className="coin-details-heading">
                                Other stats info
                            </Title>
                            <p>
                                An overview showing the statistics of {cryptoDetails?.name}, such as the base qutoe currency, the rank and trading volume
                            </p>
                        </Col>
                        {
                            genericStats.map(({icon, title, value})=>(
                                <Col className="coin-stats" key={title}>
                                    <Col className="coin-stats-name">
                                        <Text>{icon}</Text>
                                        <Text>{title}</Text>
                                    </Col>
                                    <Text className="stats">{value}</Text>
                                </Col>
                            ))
                        }
                    </Col>
                </Col>
                <Col className="coin-desc-link">
                    <Row className="coin-desc">
                        <Title level={3} className="coin-details-heading">
                            What is {cryptoDetails?.name} ?
                        </Title>
                        {HTMLReactParser(String(cryptoDetails?.description))}
                    </Row>
                    <Col className="coin-links">
                        <Title level={3} className="coin-details-heading">{cryptoDetails?.name}</Title>
                        {cryptoDetails?.links?.map((link)=>(
                            <Row className="coin-link" key={link.name}>
                                <Title level={5} className="link-name">{link.type}</Title>
                                <a href={link.url} target="_blank" rel='noreferrer'>{link.name}</a>
                            </Row>
                        ))}
                    </Col>
                </Col>

            </Col>   
        </>
    );
};

export default CryptoDetails;
